import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CloseXSvg from '../other/svg/CloseXSvg'
import { useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'

const BlockedAppModal = (): JSX.Element => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isAccountBlocked = useSelector((state: RootReducer) => state.userDataReducer.blocked)

  useEffect(() => {
    setIsModalOpen(isAccountBlocked)
  }, [isAccountBlocked])

  const handleClose = (): void => {
    setIsModalOpen(false)
  }

  if (!isModalOpen) {
    return <></>
  }

  return (
    <div className="fixed inset-0 z-[2200] flex items-center justify-center bg-groupBlue/40">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleClose} />

      <div className="relative bg-white rounded-4 shadow-bothLarge p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 hover:bg-lightGrey rounded-2 transition-colors">
          <CloseXSvg className="w-5 h-5 text-grey" />
        </button>

        <div className="text-center pt-4">
          <div className="w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                stroke="#D90A16"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 1.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>

          <h2 className="text-3xl font-Bold text-darkGrey mb-6">{t('blocked_app_modal.title')}</h2>

          <p className="text-xl text-grey mb-8 leading-relaxed">{t('blocked_app_modal.message')}</p>

          <div className="p-6 bg-lightGrey rounded-4">
            <p className="text-grey text-sm leading-relaxed">{t('blocked_app_modal.additional_info')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlockedAppModal
